module.exports = __webpack_public_path__ + "static/media/1.ebd9286a.JPG";